import axios, { AxiosInstance, AxiosError } from 'axios';

export interface ApiError {
    message: string;
    status?: number;
}

/**
 * Base API Service class providing common HTTP client functionality.
 * All domain-specific API services should extend this class.
 */
export abstract class BaseApiService {
    protected client: AxiosInstance;

    constructor() {
        this.client = axios.create({
            baseURL: import.meta.env.VITE_SERVER_URL || '',
            timeout: 20000,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${import.meta.env.VITE_SERVER_API_TOKEN}`,
            },
        });

        // Response interceptor for error handling
        this.client.interceptors.response.use(
            (response) => response,
            (error: AxiosError) => {
                const apiError: ApiError = {
                    message: 'An unexpected error occurred',
                    status: error.response?.status,
                };

                if (error.response?.data && typeof error.response.data === 'object') {
                    const data = error.response.data as Record<string, unknown>;
                    if (typeof data.message === 'string') {
                        apiError.message = data.message;
                    }
                } else if (error.message) {
                    apiError.message = error.message;
                }

                return Promise.reject(apiError);
            },
        );
    }
}
